import {PriceOverviewComponent} from './price-overview.component';
import {PriceFormComponent} from './price-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'management.price',
    component: PriceOverviewComponent,
    future: true,
    data: {
      pageTitle: 'states.price.pageTitle',
      scopes: ['management:read']
    }
  },
  {
    name: 'management.price.add',
    component: PriceFormComponent,
    future: true,
    data: {
      pageTitle: 'states.price.add.pageTitle',
      scopes: ['management:create']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class PriceRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/price/price.routes.ts